module.exports = __webpack_public_path__ + "img/Z86_17.e22ee636.jpg";